import * as React from "react"
import { Theme, useTheme } from "@mui/material/styles"
import Box from "@mui/material/Box"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import Chip from "@mui/material/Chip"
import CloseIcon from "@mui/icons-material/Close"

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
}

function getStyles(
  name: string,
  selectedValues: readonly string[],
  theme: Theme,
) {
  return {
    fontWeight: selectedValues.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  }
}

interface MultiSelectDropdownProps {
  options: string[]
  label?: string
  placeholder?: string
  selectedValues: string[]
  onChange: (selected: string[]) => void
  width?: number | string
  size?: "small" | "medium"
}

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
  options,
  // label = "Select Columns",
  // placeholder = "Select...",
  selectedValues,
  onChange,
  // width = 300,
  size = "small",
}) => {
  const theme = useTheme()

  const handleChange = (event: SelectChangeEvent<typeof selectedValues>) => {
    const {
      target: { value },
    } = event
    onChange(typeof value === "string" ? value.split(",") : value)
  }

  const handleRemoveColumn = (event: React.MouseEvent, column: string) => {
    event.stopPropagation()
    const updatedColumns = selectedValues.filter((col) => col !== column)
    onChange(updatedColumns)
  }

  return (
    <FormControl fullWidth size={size}>
      <Select
        multiple
        displayEmpty
        value={selectedValues}
        onChange={handleChange}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value, index) => (
              <Chip
                key={index}
                label={value}
                onDelete={(event) => handleRemoveColumn(event, value)}
                deleteIcon={<CloseIcon sx={{ height: 16 }} />}
                variant="filled"
                sx={{
                  backgroundColor: "customColors.positive",
                  color: "customColors.textGreen",
                  // "&:hover": {
                  //   backgroundColor: theme.palette.primary.main,
                  // },
                  borderRadius: 1,
                  p: 0,
                  fontSize: 11,
                  fontWeight: 600,
                }}
                size="small"
                onMouseDown={(event) => {
                  event.stopPropagation()
                }}
              />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {options.map((option) => (
          <MenuItem
            key={option}
            value={option}
            style={getStyles(option, selectedValues, theme)}
          >
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default MultiSelectDropdown
